import React, {useEffect, useState} from 'react';
import {View, TextInput, TouchableOpacity} from 'react-native';
import {styles} from './styles';

export default function ValueController({
  initialValue = 0,
  onUpdate,
  minValue = 0,
  maxValue = 99,
  containerStyle,
  inputStyle,
  testIdPrefix = 'value',
  incrementTestId = 'addToteButton',
  decrementTestId = 'removeToteButton',
  allowDecimals = false,
  step = 1
}) {
  const [localValue, setLocalValue] = useState(initialValue?.toString());
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setLocalValue(initialValue.toString());
    }
  }, [initialValue, isEditing]);

  const handleSubmit = () => {
    setIsEditing(false);
    const numValue = allowDecimals ? parseFloat(localValue) : parseInt(localValue, 10);
    if (!isNaN(numValue) && numValue >= minValue && numValue <= maxValue) {
      onUpdate(numValue);
    } else {
      setLocalValue(initialValue.toString());
    }
  };

 const handleChange = text => {
    if (text === '') {
      setLocalValue(text);
      return;
    }

    if (allowDecimals) {
      const decimalRegex = /^(?:0\.?[1-9]?|[1-9][0-9]?\.?[0-9]?)$/;
      if (decimalRegex.test(text)) {
        if (text.endsWith('.') || text === '0') {
          setLocalValue(text);
          return;
        }
        const numValue = parseFloat(text);
        if (!isNaN(numValue) && numValue >= minValue && numValue <= maxValue) {
          setLocalValue(text);
        }
      }
    } else {
      if (/^\d+$/.test(text) && parseInt(text, 10) <= maxValue) {
        setLocalValue(text);
      }
    }
  };

  const incrementValue = () => {
    const currentValue = allowDecimals ? parseFloat(initialValue) : parseInt(initialValue, 10);
    const newValue = Math.min(maxValue, currentValue + step);
    onUpdate(allowDecimals ? Math.round(newValue * 10) / 10 : newValue);
  };

  const decrementValue = () => {
    const currentValue = allowDecimals ? parseFloat(initialValue) : parseInt(initialValue, 10);
    const newValue = Math.max(minValue, currentValue - step);
    onUpdate(allowDecimals ? Math.round(newValue * 10) / 10 : newValue);
  };

  return (
    <View style={containerStyle}>
      <TextInput
        testID={`${testIdPrefix}Input`}
        style={inputStyle}
        value={localValue}
        onChangeText={handleChange}
        onFocus={() => setIsEditing(true)}
        onBlur={handleSubmit}
        onSubmitEditing={handleSubmit}
        keyboardType={allowDecimals ? "decimal-pad" : "numeric"}
        maxLength={allowDecimals ? 4 : 2}
        returnKeyType="done"
      />
      <View>
        <TouchableOpacity
          testID={incrementTestId}
          style={styles.countButton}
          onPress={incrementValue}>
          <i
            className="icon-up-open"
            style={{fontSize: 18, color: '#ffff'}}></i>
        </TouchableOpacity>
        <TouchableOpacity
          testID={decrementTestId}
          style={styles.countButton}
          onPress={decrementValue}>
          <i
            className="icon-down-open"
            style={{fontSize: 18, color: '#ffff'}}></i>
        </TouchableOpacity>
      </View>
    </View>
  );
}
